// utils/heatmapColor.js

export function heatmapColor(value, min, max) {
  if (value === null || value === undefined) return "#ffffff";
  if (max === min) return "#fee5d9";

  const ratio = (value - min) / (max - min);

  // 🔥 Escala térmica real (blanco → rojo oscuro)
  if (ratio >= 0.9) return "#7f0000";   // muy caliente
  if (ratio >= 0.75) return "#b30000";
  if (ratio >= 0.6) return "#e34a33";
  if (ratio >= 0.45) return "#fc8d59";
  if (ratio >= 0.3) return "#fdbb84";
  if (ratio >= 0.15) return "#fdd49e";

  return "#fff5f0";                     // frío
}

export function textColor(bgColor) {
  // Colores oscuros → texto blanco
  const dark = [
    "#7f0000",
    "#b30000",
    "#e34a33"
  ];
  return dark.includes(bgColor) ? "#fff" : "#000";
}
